export const previewKeys = {
  single: (id: number) => ['LANDING_PAGE_DESIGN_PREVIEW', id],
};
